import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { TemplateSettings } from '../../store/interfaces';

export const LanguageDropdownStyles = makeStyles((theme: Theme) =>
  createStyles({
    languageList: (props: TemplateSettings) => ({
      backgroundColor: BrandColors.blackWithOpacity1,
      color: props.utilityBar.textColor,
      boxShadow: 'none',
      border: 'none',
      maxHeight: '200px',
      overflow: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: '4px',
      outline: 'none',
      [theme.breakpoints.up('lg')]: {
        backgroundColor: 'inherit',
      },
      '& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover': {
        backgroundColor: BrandColors.blackWithOpacity25,
      },
      '& span': {
        color: props.utilityBar.textColor,
      },
      '& .MuiListItem-root': {
        padding: '0.25em 0.5em',
        margin: '0.125em 0',
      },
      '& .MuiListItemText-root': {
        margin: '0',
      },
    }),
  }),
);
